import React from 'react';

function Help()
{
    return(
        <div className='help'>
            <h3>Let Us Help You</h3>
            <p>
                EarthMed is dedicated to helping you with your medical marijuana needs with expertise and compassion. EarthMed combines accessibility, class and comort for patients seeking alternative medicine though medica marijuana. We believe this forucs on comfort, overall wellness, and health will createa comfortable warm, and happy enviornment which makes EarthMed the premier destination for medical marijuana patients in Illinois.
            </p>
            <p>
                In order for us to get in touch with you to discuss he medical marijuana treatment options available to you, please fill out the form to the right. Once we recieve your request for information, someone from our team will be in contact with you to help you recieve the medical marijuana treatment that you need and deserve.
            </p>
        </div>
    );
}


export default Help;